import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../contexts/AuthContext";
import dayjs from "dayjs";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const ActivityChart = () => {
  const { user } = useAuth();
  const [weeklyData, setWeeklyData] = useState([]);

  useEffect(() => {
    if (user) fetchWeeklyCalories();
  }, [user]);

  const fetchWeeklyCalories = async () => {
    const startOfWeek = dayjs().subtract(6, "day").startOf("day").toISOString();

    const { data, error } = await supabase
      .from("meal_logs")
      .select("created_at, calories")
      .eq("user_id", user.id)
      .gte("created_at", startOfWeek);

    if (error) {
      console.error("Error loading weekly data:", error);
      return;
    }

    // Prepare array for last 7 days → Mon-Sun style labels
    const days = [];
    for (let i = 6; i >= 0; i--) {
      const date = dayjs().subtract(i, "day");
      days.push({
        dateStr: date.format("YYYY-MM-DD"),
        day: date.format("ddd"), // Mon, Tue, ...
        calories: 0
      });
    }

    // Sum calories per day
    data.forEach((entry) => {
      const entryDay = dayjs(entry.created_at).format("YYYY-MM-DD");
      const dayObj = days.find((d) => d.dateStr === entryDay);

      if (dayObj) {
        dayObj.calories = Math.round(dayObj.calories + Number(entry.calories || 0));
      }
    });

    setWeeklyData(days);
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Weekly Activity</h3>
          <p className="text-sm text-gray-500 mt-1">Calorie intake over the week</p>
        </div>

        <button className="text-emerald-600 hover:text-emerald-700 font-medium text-sm">
          View Details
        </button>
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={weeklyData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
          <XAxis
            dataKey="day"
            stroke="#9ca3af"
            style={{ fontSize: "12px" }}
          />
          <YAxis stroke="#9ca3af" style={{ fontSize: "12px" }} />
          <Tooltip
            formatter={(value) => [`${value} kcal`, "Calories"]}
            contentStyle={{
              backgroundColor: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
            }}
          />
          <Bar dataKey="calories" fill="#10b981" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityChart;
